module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/developer/gulp-96c26e6af9a6cb1e142fa661df4934d0.svg";